var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSofa2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 43.0834C21.6609 43.0834 23.6533 43.9087 25.1223 45.3777C26.5914 46.8467 27.4167 48.8392 27.4167 50.9167V58.75H66.5833V50.9167C66.5833 48.8392 67.4086 46.8467 68.8777 45.3777C70.3467 43.9087 72.3391 43.0834 74.4167 43.0834C76.4942 43.0834 78.4866 43.9087 79.9557 45.3777C81.4247 46.8467 82.25 48.8392 82.25 50.9167V66.5834C82.25 68.6609 81.4247 70.6533 79.9557 72.1224C78.4866 73.5914 76.4942 74.4167 74.4167 74.4167H19.5833C17.5058 74.4167 15.5134 73.5914 14.0443 72.1224C12.5753 70.6533 11.75 68.6609 11.75 66.5834V50.9167C11.75 48.8392 12.5753 46.8467 14.0443 45.3777C15.5134 43.9087 17.5058 43.0834 19.5833 43.0834V43.0834Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7895 42.0526V27.3651C19.7895 25.0279 21.0181 22.7864 23.2051 21.1337C25.3921 19.4811 28.3583 18.5526 31.4511 18.5526H62.5489C65.6418 18.5526 68.6079 19.4811 70.7949 21.1337C72.9819 22.7864 74.2105 25.0279 74.2105 27.3651V42.0526",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 74.4166V82.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5 74.4166V82.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSofa2);
export default __webpack_public_path__ + "static/media/icon-sofa-2.a048da167579768f9efcbc8fadb18a2b.svg";
export { ForwardRef as ReactComponent };